module.exports = {
  createActivityStoryComment: function (body) {
    return this.client.post('/v7.0/activity_story/', body)
  },
}



// WEBPACK FOOTER //
// ./shared/mapmy/activityStory.js